module.exports = vendors_6cb917d60fb74bc9abe2;